const isNil = (value) => {
	return value === null || value === undefined || value === '';
};

export default isNil;
